//hooks
import UseContentPost from "./ContentPost.hooks";

//components
import { ContentImagePreviewPanel, ActionFeedbackBanner } from "thrive-components";
import CommentInputPanel from "../../elements/commentInputPanel/CommentInputPanel";
import ContentTitle from "../../elements/contentTitle/ContentTitle";
import ActivityInformationPanel from "../../elements/activityInformationPanel/ActivityInformationPanel";
import DeletedBanner from "../../elements/deletedComment/DeletedComment";
import ArchiveContent from "../../elements/archiveContent/ArchiveContent";
import ApprovePanel from "../../elements/approvePanel/ApprovePanel";
import ActivityProfileData from "../../elements/activityProfileData/ActivityProfileData";
import ContentPostTitle from "../../elements/notificationTitle/ContentPostTitle/ContentPostTitle";

//interfaces
import { UserActivity } from "@/interfaces/activityFeed";
import { IContentPost } from "@/interfaces/activityFeedNotifications";

import "../../../../../css/activityFeed/notifications/content-posted-activity.scss";



const ContentPosted = ({zIndexNum, activityId, isPopOut = false, timeStamp, dateStamp, user, parentList, notificationDetails, isRemovedFromParentList, getOpenOnWebLink, onArchiveContentClick, onPostCommentClick, onLikeClick, content, appDetails, editorProfileImage, isModeratedContent, needsApproval, meta, onApproveClick}: IContentPost) => {
    const {screenClassName, archivedClassName, handleLikeClick, handleReplyClick, webLink, handleArchiveClick, handleApproveClick, showMenu, showFeedbackBanner, feedbackType, feedbackMessage, commentString, setCommentString, onCommentClick, showCommentFunctionality, setShowCommentFunctionality, contentIsRemoved, deletedBannerMessage, showApprovalPanel, showArchiveContent, hideArchiveFunctionality, onArchiveClick, activityInfo, isPosting} = UseContentPost({activityId, isPopOut, timeStamp, dateStamp, parentList, content, notificationDetails, isRemovedFromParentList, getOpenOnWebLink, onArchiveContentClick, onPostCommentClick, onLikeClick, meta, appDetails, isModeratedContent, needsApproval, onApproveClick});

    return (
        <div className={`${isPopOut ? "" : "content-posted-full"} content-posted notification-wrapper`}>
            <div className="top-row">
                <ActivityProfileData 
                    isPopOut={isPopOut}
                    imageUrl={user.imageUrl}
                    userActivity={UserActivity.contentPosted} 
                    timeStamp={timeStamp}
                    dateStamp={dateStamp}
                />
                
                <ContentPostTitle
                    parentList={parentList} 
                    isPopOut={isPopOut} 
                    user={user.name} 
                />
            </div>        

            <ContentTitle 
                zIndexNum={zIndexNum}
                className={`${screenClassName} ${archivedClassName}`} 
                contentTitle={content.title} 
                isLiked={meta.hasLiked} 
                onLikeClick={handleLikeClick} 
                onReplyClick={handleReplyClick}
                getWebLink={webLink} 
                onArchiveContentClick={handleArchiveClick} 
                onApproveContentClick={handleApproveClick}
                showMenu={showMenu}
            />

            <ContentImagePreviewPanel 
                className={screenClassName}
                mediaItems={content.media} 
                maxVisible={5} 
                totalMediaItems={content.totalMediaItems} 
            />
            
            {showFeedbackBanner && 
                <ActionFeedbackBanner 
                    feedbackType={feedbackType} 
                    feedbackMessage={feedbackMessage} 
                />
            }

            <CommentInputPanel 
                className={screenClassName} 
                commentString={commentString} 
                setCommentString={setCommentString} 
                onPostCommentClick={onCommentClick} 
                showCommentFunctionality={showCommentFunctionality} 
                setShowCommentFunctionality={setShowCommentFunctionality} 
                profileImageUrl={editorProfileImage}
                isPosting={isPosting}
            />   

            <DeletedBanner 
                isDeleted={contentIsRemoved} 
                message={deletedBannerMessage}
            />

            {showApprovalPanel && 
                <ApprovePanel 
                    className={screenClassName}
                    onApprovalClick={onApproveClick} 
                    needsApproval={needsApproval}
                />
            }

            <ArchiveContent 
                showModal={showArchiveContent} 
                existsInMultiplePlaces={content.existsInMultiplePlaces} 
                onCloseClick={hideArchiveFunctionality} 
                onConfirmClick={onArchiveClick}  
                isInlineStyle={isPopOut}
            />

            <ActivityInformationPanel
               {...activityInfo}
            />
        </div>
    )
};

export default ContentPosted